<template>
  <div class="row ici-widget">
    <div class="benefits-snapshot" @click="requestVideo">
      <img
        src="https://teslawebclientconfig.blob.core.windows.net/sites/iciscpf.lcp.uk.com/img/video-home.png"
      />
    </div>
    <div class="actions">
      <div class="benefits-video flex" @click="requestVideo">
        <div class="icon">
          <font-awesome-icon :icon="['fal', 'play-circle']" />
        </div>
        <div class="text">
          Benefits of registering
          <span>Click here to watch our video</span>
        </div>
      </div>
      <div class="view-guide flex" @click="downloadGuide">
        <div class="icon">
          <font-awesome-icon :icon="['fal', 'file-pdf']" />
        </div>
        <div class="text">
          Step-by-step guide to registering
          <span>Click here to read and download</span>
        </div>
      </div>
    </div>

    <transition-group name="fade">
      <div class="video-modal" v-if="vimeoData" key="videoModal">
        <div class="bg"></div>
        <div class="modal-inner">
          <div class="card p-4">
            <div class="close-icon" @click="resetVideoData">
              <font-awesome-icon :icon="['fal', 'times']" />
            </div>
            <div class="responsive-video">
              <div v-html="vimeoData.html" />
            </div>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'ICI-Homepage-Tile',
    data () {
        return {
            vimeoData: null,
        };
    },
    computed: {
        directoryUrl () {
            return this.$store.state.clientConfig.directoryUrl;
        },
    },
    methods: {
        requestVideo () {
            let authSet = '';
            if (axios.defaults.headers.common.Authorization) {
                authSet = axios.defaults.headers.common.Authorization;
                axios.defaults.headers.common = {};
            }
            if (axios.defaults.headers.get.ImpersonateId) {
                axios.defaults.headers.get = {};
            }
            axios({
                method: 'get', // you can set what request you want to be
                url: 'https://vimeo.com/api/oembed.json?url=https://vimeo.com/655008862/cfef9aa646&width=700',
                headers: {},
            }).then((response) => {
                // handle success
                this.vimeoData = response.data;
            });
            if (authSet !== '') {
                axios.defaults.headers.common.Authorization = authSet;
            }
        },
        resetVideoData () {
            this.vimeoData = null;
        },
        downloadGuide () {
            window.open(
                'https://teslawebclientconfig.blob.core.windows.net/sites/iciscpf.lcp.uk.com/documents/iciscpf-registration-guide.pdf',
                '_blank',
            );
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_mixins.scss';

.ici-widget {
  .benefits-snapshot {
    cursor: pointer;
        border: 5px solid #0c5a99;
    box-sizing: border-box;
    border-radius: 6px;
    img {
      width: 100%;
      max-width: 390px;
      border-radius: 10px 10px 0 0;
    }
    z-index: 2;
  }
  .actions {
    margin-top: -25px;
    width: 400px;
    .icon {
      font-size: 30px;
      margin-right: 20px;
    }
    span {
      display: block;
      font-weight: normal;
    }
    .text {
      font-weight: bold;
    }

    .view-guide,
    .benefits-video {
      background: #f26d2c;
      color: white;
      padding: 20px;
      border-radius: 10px;
      cursor: pointer;
    }
    .view-guide {
      margin-top: 20px;
    }
    .benefits-video {
      padding-top: 40px;
      background: #0c5a99;
    }
  }
  .video-modal {
    z-index: 3;
    .bg {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.2);
    }
    .modal-inner {
      z-index: 10;
      position: fixed;
      left: 50%;
      top: 50%;
      width: 700px;
      transform: translate(-50%, -50%);
      @include responsive('sm') {
        width: 360px;
        .p-4 {
          padding: 10px !important;
        }
        .close-icon {
          z-index: 3;
        }
      }
      .card {
        position: relative;
        box-shadow: $boxShadow;
        .close-icon {
          position: absolute;
          top: -10px;
          right: -10px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: white;
          font-size: 20px;
          text-align: center;
          cursor: pointer;
          box-shadow: $boxShadow;
        }
      }
      .responsive-video {
        position: relative;
        overflow: hidden;
        padding-top: 56.25%;
        ::v-deep iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: 0;
        }
      }
    }
  }
}
</style>
